import './HtmlBlock.css';

interface HtmlBlockProps {
  html?: string;
}

export const HtmlBlock = ({ html = '' }: HtmlBlockProps) => {
  return (
    <div className='html-block'>
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
    </div>
  );
};
